/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Board_Top_TitleInputs */

const en_directory_home_board_top_title = /** @type {(inputs: Directory_Home_Board_Top_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top products`)
};

const zh_directory_home_board_top_title = /** @type {(inputs: Directory_Home_Board_Top_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热门产品`)
};

/**
* | output |
* | --- |
* | "Top products" |
*
* @param {Directory_Home_Board_Top_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_board_top_title = /** @type {((inputs?: Directory_Home_Board_Top_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Board_Top_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_board_top_title(inputs)
	return zh_directory_home_board_top_title(inputs)
});
export { directory_home_board_top_title as "directory.home.board.top_title" }